var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carBox carBoxLeft"},[_c('el-alert',{attrs:{"title":"权限异常","type":"warning","description":"未获得访问权限，请联系管理员！","show-icon":"","closable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }